import {
  DeleteSupplierItemReqData,
  PostSupplierItemReq,
  PutSupplierItemReqData
} from '@gateway.maintenance'
import { yamadumiApi } from '../yamadumi-api'
export class SupplierItemGateway {
  /**
   * 業者マスタメンテナンス-明細削除
   */
  static DeleteSupplierItem = async (params: DeleteSupplierItemReqData) => {
    return await yamadumiApi.put(
      '/api/maintenance/supplier/item/delete/part',
      params
    )
  }

  /**
   *  業者マスタメンテナンス-登録
   */
  static PostSupplieInputItem = async (params: PostSupplierItemReq) => {
    return await yamadumiApi.post('/api/maintenance/supplier/item', params)
  }

  /**
   * 業者マスタメンテナンス-更新
   */
  static PutSupplieInputItem = async (params: PutSupplierItemReqData) => {
    return await yamadumiApi.put('/api/maintenance/supplier/item', params)
  }
}
